import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import API, { BASE_URL } from "../api/Api"; // adjust path

const CSRGallery = () => {
 const [galleryData, setGalleryData] = useState([]);
const [years, setYears] = useState([]);
const [events, setEvents] = useState([]);

const [selectedYear, setSelectedYear] = useState("");
const [selectedEvent, setSelectedEvent] = useState("");
const [search, setSearch] = useState("");

const [page, setPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);  

 useEffect(() => {
  fetchGallery();
}, [page, selectedYear, selectedEvent]);


useEffect(() => {
  const delay = setTimeout(() => {
    setPage(1);
    fetchGallery();
  }, 500);

  return () => clearTimeout(delay);
}, [search]);
const fetchGallery = async () => {
  try {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("limit", 9);

    if (selectedYear) {
      params.append("year", selectedYear);
    }

    if (selectedEvent) {
      params.append("event_name", selectedEvent);
    }

    if (search) {
      params.append("search", search);
    }

    const res = await API.get(`/gallery?${params.toString()}`);

    if (res.data.success) {
      setGalleryData(res.data.data);

      setYears(res.data.filters.years || []);
      setEvents(res.data.filters.events || []);

      setTotalPages(res.data.pagination.totalPages || 1);
    }
  } catch (error) {
    console.error("Gallery API Error:", error);
  }
};

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="container my-4">

      {/* FILTER */}
    <div className="csr-filter-box mb-5">
  <div className="row g-3 align-items-end">

    <div className="col-lg-3 col-md-6">
      <label className="csr-filter-title">
        <i className="fa-solid fa-calendar-days me-2"></i>
        Year
      </label>

      <select
        className="form-select csr-select"
        value={selectedYear}
        onChange={(e) => {
          setSelectedYear(e.target.value);
          setPage(1);
        }}
      >
        <option value="">All Years</option>

        {years.map((item) => (
          <option key={item.year} value={item.year}>
            {item.year}
          </option>
        ))}
      </select>
    </div>

    <div className="col-lg-3 col-md-6">
      <label className="csr-filter-title">
        <i className="fa-solid fa-tag me-2"></i>
        Event Type
      </label>

      <select
        className="form-select csr-select"
        value={selectedEvent}
        onChange={(e) => {
          setSelectedEvent(e.target.value);
          setPage(1);
        }}
      >
        <option value="">All Event Types</option>

        {events.map((item, index) => (
          <option key={index} value={item.event_name}>
            {item.event_name}
          </option>
        ))}
      </select>
    </div>

    <div className="col-lg-4 col-md-8">
      <label className="csr-filter-title">
        <i className="fa-solid fa-magnifying-glass me-2"></i>
        Search
      </label>

      <div className="csr-search-wrap">
        <input
          type="text"
          className="form-control csr-search"
          placeholder="Search by title, event or location..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    </div>

    <div className="col-lg-2 col-md-4">
      <button
        className="btn csr-reset-btn w-100"
        onClick={() => {
          setSelectedYear("");
          setSelectedEvent("");
          setSearch("");
          setPage(1);
        }}
      >
        <i className="fa-solid fa-rotate-left me-2"></i>
        Reset
      </button>
    </div>

  </div>
</div>

      {/* COUNT */}
      <div className="csr-count-text mb-3">
        Showing {galleryData.length} images
      </div>

      {/* CARDS */}
      <div className="row g-4">
        {galleryData.map((item) => (
          <div key={item.gallery_id} className="col-lg-4 col-md-6">
            <div className="csr-card-gallery">
              <div className="csr-img-wrap">
                <span className="csr-badge badge-edu">
                  {item.event_name}
                </span>
                <img
                  src={`${BASE_URL}/assets/images/${item.image}`}
                  alt={item.title}
                />
              </div>

              <div className="csr-card-body">
                <h6 className="csr-title">{item.title}</h6>
                <ul className="csr-meta">
                  <li>
                    <i className="fa-regular fa-bookmark"></i>
                    {item.event_name}
                  </li>
                  <li>
                    <i className="fa-solid fa-location-dot"></i>
                    {item.location}
                  </li>
                  <li>
                    <i className="fa-regular fa-calendar"></i>
                    {formatDate(item.date)}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
<div className="d-flex justify-content-center mt-5">
  <nav>
    <ul className="pagination">

      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => setPage(page - 1)}
        >
          Previous
        </button>
      </li>

      {[...Array(totalPages)].map((_, index) => (
        <li
          key={index}
          className={`page-item ${
            page === index + 1 ? "active" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => setPage(index + 1)}
          >
            {index + 1}
          </button>
        </li>
      ))}

      <li
        className={`page-item ${
          page === totalPages ? "disabled" : ""
        }`}
      >
        <button
          className="page-link"
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </li>

    </ul>
  </nav>
</div>
    </div>
  );
};

export default CSRGallery;
